import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../interfaces/common.interfaces';
import {
  ComisionesRequest,
  PayStubResponse,
  CommissionDetailsResponse,
  CollectionCommissionResponse,
} from '../interfaces/comisiones.interface';
import { environment } from '../../environments/environment';

export enum TipoDocumentoComisiones {
  VOLANTE_PAGO = 1,
  DETALLES = 2,
  DETALLES_POR_COBRO = 3,
}

@Injectable({
  providedIn: 'root',
})
export class ComisionesService {
  private apiUrl = environment.int365_dom + '/api/v1/Commission';

  constructor(private http: HttpClient, private authService: AuthService) { }

  // Volante de Pago
  getCommissionPaystub(
    request: ComisionesRequest
  ): Observable<HttpResponse<ApiResponse<PayStubResponse[]>>> {
    return this.http.get<ApiResponse<PayStubResponse[]>>(
      `${this.apiUrl}/paystub`,
      {
        ...this.getHttpOptions(request),
        observe: 'response',
        responseType: 'json',
      }
    )
  }

  // Detalles
  getCommissionDetails(
    request: ComisionesRequest
  ): Observable<HttpResponse<ApiResponse<CommissionDetailsResponse[]>>> {
    return this.http
      .get<ApiResponse<CommissionDetailsResponse[]>>(
        `${this.apiUrl}/detail`,
        {
          ...this.getHttpOptions(request),
          observe: 'response',
          responseType: 'json',
        }
      )
  }

  // Detalles por Cobro
  getCommissionCollections(
    request: ComisionesRequest
  ): Observable<HttpResponse<ApiResponse<CollectionCommissionResponse[]>>> {
    return this.http
      .get<ApiResponse<CollectionCommissionResponse[]>>(
        `${this.apiUrl}/collections`,
        {
          ...this.getHttpOptions(request),
          observe: 'response',
          responseType: 'json',
        }
      )
  }

  // Autenticación
  private getHttpOptions(params?: any) {
    const token = this.authService.getToken();
    if (!token) throw new Error('No token found');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return {
      headers,
      params: params
        ? new HttpParams({ fromObject: this.formatParams(params) })
        : undefined,
    };
  }

  // Formato de parámetros
  private formatParams(params: any): { [key: string]: string } {
    const formattedParams: { [key: string]: string } = {};

    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined) return;

      if (value instanceof Date) {
        formattedParams[key] = value.toISOString().split('T')[0];
      } else {
        formattedParams[key] = String(value);
      }
    });

    return formattedParams;
  }
}
